module.exports = __webpack_public_path__ + "img/model_18_ug.1387606e.jpg";